/// <reference path='../../modules/app.module.ts'/>
/// <reference path="../../controllers/shell.controller.ts" />

module App {
    var getRoutes = (): App.Interfaces.ICustomState[] => {
        var route: App.Interfaces.ICustomState = {
            name: Constants.routeKeys.products,
            url: '/' + 'products',
            cache: false,
            title: 'Werkzaamheden',
            headerTitle: 'Kies uw werkzaamheden',
            configuratorStepName: ['ProductStep'],
            order: 3,
            operations: ['SetProduct'],
            views: {
                [Constants.viewRegions.appContent]: {
                    templateUrl: '/templates/products.html',
                    controller: Controllers.ProductsController.controllerId + ' as vm'
                }
            },
            showInMenu: true
        }

        return [route];
    }

    function appRun(routehelper: Blocks.Interfaces.IRouterFactory) {
        routehelper.configureRoutes(getRoutes());
    }

    App.Core.appCore.run(appRun);
}